export const REQUEST_DELETEPROJECT = 'REQUEST_DELETEPROJECT';
export const DELETEPROJECT_RECEIVED = 'DELETEPROJECT_RECEIVED';

